package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Double
import kotlin.Long
import kotlin.String
import migrations.InspectionTable

public class InspectionTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getAllInspections(userId: String, mapper: (
    id: String,
    templateId: String,
    templateName: String,
    vesselName: String?,
    totalAnswer: Long,
    totalQuestion: Long,
    lastUpdated: String,
    status: String,
    userId: String,
    conducted: String?,
  ) -> T): Query<T> = GetAllInspectionsQuery(userId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getString(9)
    )
  }

  public fun getAllInspections(userId: String): Query<InspectionTable> = getAllInspections(userId, ::InspectionTable)

  public fun <T : Any> getInspectionById(id: String, mapper: (
    id: String,
    templateId: String,
    templateName: String,
    vesselName: String?,
    totalAnswer: Long,
    totalQuestion: Long,
    lastUpdated: String,
    status: String,
    userId: String,
    conducted: String?,
  ) -> T): Query<T> = GetInspectionByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getString(9)
    )
  }

  public fun getInspectionById(id: String): Query<InspectionTable> = getInspectionById(id, ::InspectionTable)

  public fun <T : Any> getFullInspection(id: String, mapper: (
    inspection_id: String,
    template_id: String,
    template_name: String,
    vesselName: String?,
    totalAnswer: Long,
    totalQuestion: Long,
    lastUpdated: String,
    status: String,
    conducted: String?,
    t_id: String?,
    t_name: String?,
    version: Long?,
    publishedDate: String?,
    numberOfPages: Long?,
    numberOfSections: Long?,
    numberOfQuestions: Long?,
    page_id: String?,
    page_title: String?,
    page_pos: Long?,
    section_id: String?,
    section_title: String?,
    section_pos: Long?,
    q_id: String?,
    questionText: String?,
    guidelines: String?,
    required: Boolean?,
    q_pos: Long?,
    answerType: String?,
    failedOptionId: String?,
    neutralOptionId: String?,
    answer_id: String?,
    notes: String?,
    isRequiredFileOrNotes: Boolean?,
    answerDateIso: String?,
    answerOptionId: String?,
    answerText: String?,
    answerLastUpdated: String?,
    findingCategory: String?,
    answer_selection_id: String?,
    answerSelectionId: String?,
    answerSelectionValue: String?,
    answer_file_id: String?,
    answerFileName: String?,
    answerFilePath: String?,
    answerFileSize: Long?,
    answerFileType: String?,
    answerFileStatus: String?,
    answer_location_id: String?,
    answerLocationName: String?,
    latitude: Double?,
    longitude: Double?,
    street: String?,
    isoCountryCode: String?,
    country: String?,
    postalCode: String?,
    administrativeArea: String?,
    subAdministrativeArea: String?,
    locality: String?,
    subLocality: String?,
    thoroughfare: String?,
    subThoroughfare: String?,
  ) -> T): Query<T> = GetFullInspectionQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getLong(13),
      cursor.getLong(14),
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getLong(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getLong(21),
      cursor.getString(22),
      cursor.getString(23),
      cursor.getString(24),
      cursor.getBoolean(25),
      cursor.getLong(26),
      cursor.getString(27),
      cursor.getString(28),
      cursor.getString(29),
      cursor.getString(30),
      cursor.getString(31),
      cursor.getBoolean(32),
      cursor.getString(33),
      cursor.getString(34),
      cursor.getString(35),
      cursor.getString(36),
      cursor.getString(37),
      cursor.getString(38),
      cursor.getString(39),
      cursor.getString(40),
      cursor.getString(41),
      cursor.getString(42),
      cursor.getString(43),
      cursor.getLong(44),
      cursor.getString(45),
      cursor.getString(46),
      cursor.getString(47),
      cursor.getString(48),
      cursor.getDouble(49),
      cursor.getDouble(50),
      cursor.getString(51),
      cursor.getString(52),
      cursor.getString(53),
      cursor.getString(54),
      cursor.getString(55),
      cursor.getString(56),
      cursor.getString(57),
      cursor.getString(58),
      cursor.getString(59),
      cursor.getString(60)
    )
  }

  public fun getFullInspection(id: String): Query<GetFullInspection> = getFullInspection(id, ::GetFullInspection)

  public fun <T : Any> getInspectionsPaginated(
    userId: String,
    limit: Long,
    offset: Long,
    mapper: (
      id: String,
      templateId: String,
      templateName: String,
      vesselName: String?,
      totalAnswer: Long,
      totalQuestion: Long,
      lastUpdated: String,
      status: String,
      userId: String,
      conducted: String?,
    ) -> T,
  ): Query<T> = GetInspectionsPaginatedQuery(userId, limit, offset) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8)!!,
      cursor.getString(9)
    )
  }

  public fun getInspectionsPaginated(
    userId: String,
    limit: Long,
    offset: Long,
  ): Query<InspectionTable> = getInspectionsPaginated(userId, limit, offset, ::InspectionTable)

  public fun countInspections(userId: String): Query<Long> = CountInspectionsQuery(userId) { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertInspection(
    id: String,
    templateId: String,
    templateName: String,
    vesselName: String?,
    totalAnswer: Long,
    totalQuestion: Long,
    lastUpdated: String,
    status: String,
    userId: String,
    conducted: String?,
  ): QueryResult<Long> {
    val result = driver.execute(901_604_401, """
        |INSERT INTO InspectionTable(id, templateId, templateName, vesselName, totalAnswer, totalQuestion, lastUpdated, status, userId, conducted)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   templateId=excluded.templateId,
        |   templateName=excluded.templateName,
        |   vesselName=excluded.vesselName,
        |   totalAnswer=excluded.totalAnswer,
        |   totalQuestion=excluded.totalQuestion,
        |   lastUpdated=excluded.lastUpdated,
        |   status=excluded.status,
        |   userId=excluded.userId,
        |   conducted=excluded.conducted
        """.trimMargin(), 10) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, templateId)
          bindString(parameterIndex++, templateName)
          bindString(parameterIndex++, vesselName)
          bindLong(parameterIndex++, totalAnswer)
          bindLong(parameterIndex++, totalQuestion)
          bindString(parameterIndex++, lastUpdated)
          bindString(parameterIndex++, status)
          bindString(parameterIndex++, userId)
          bindString(parameterIndex++, conducted)
        }
    notifyQueries(901_604_401) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceInspection(
    id: String,
    templateId: String,
    templateName: String,
    vesselName: String?,
    totalAnswer: Long,
    totalQuestion: Long,
    lastUpdated: String,
    status: String,
    userId: String,
    conducted: String?,
  ): QueryResult<Long> {
    val result = driver.execute(-1_018_178_069, """
        |INSERT OR REPLACE INTO InspectionTable(id, templateId, templateName, vesselName, totalAnswer, totalQuestion, lastUpdated, status, userId, conducted)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, templateId)
          bindString(parameterIndex++, templateName)
          bindString(parameterIndex++, vesselName)
          bindLong(parameterIndex++, totalAnswer)
          bindLong(parameterIndex++, totalQuestion)
          bindString(parameterIndex++, lastUpdated)
          bindString(parameterIndex++, status)
          bindString(parameterIndex++, userId)
          bindString(parameterIndex++, conducted)
        }
    notifyQueries(-1_018_178_069) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun updateProgress(
    totalAnswer: Long,
    lastUpdated: String,
    vesselName: String?,
    id: String,
  ): QueryResult<Long> {
    val result = driver.execute(198_707_770, """UPDATE InspectionTable SET totalAnswer = ?, lastUpdated = ?, vesselName = ? WHERE id = ?""", 4) {
          var parameterIndex = 0
          bindLong(parameterIndex++, totalAnswer)
          bindString(parameterIndex++, lastUpdated)
          bindString(parameterIndex++, vesselName)
          bindString(parameterIndex++, id)
        }
    notifyQueries(198_707_770) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun updateStatus(
    status: String,
    lastUpdated: String,
    id: String,
  ): QueryResult<Long> {
    val result = driver.execute(-1_968_326_849, """UPDATE InspectionTable SET status = ?, lastUpdated = ? WHERE id = ?""", 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, status)
          bindString(parameterIndex++, lastUpdated)
          bindString(parameterIndex++, id)
        }
    notifyQueries(-1_968_326_849) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteInspectionById(id: String): QueryResult<Long> {
    val result = driver.execute(-245_209_323, """DELETE FROM InspectionTable WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }
    notifyQueries(-245_209_323) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllInspections(userId: String): QueryResult<Long> {
    val result = driver.execute(1_952_814_285, """DELETE FROM InspectionTable WHERE userId = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, userId)
        }
    notifyQueries(1_952_814_285) { emit ->
      emit("InspectionTable")
    }
    return result
  }

  private inner class GetAllInspectionsQuery<out T : Any>(
    public val userId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("InspectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("InspectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_266_264_208, """SELECT InspectionTable.id, InspectionTable.templateId, InspectionTable.templateName, InspectionTable.vesselName, InspectionTable.totalAnswer, InspectionTable.totalQuestion, InspectionTable.lastUpdated, InspectionTable.status, InspectionTable.userId, InspectionTable.conducted FROM InspectionTable WHERE userId = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, userId)
    }

    override fun toString(): String = "InspectionTable.sq:getAllInspections"
  }

  private inner class GetInspectionByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("InspectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("InspectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(830_679_480, """SELECT InspectionTable.id, InspectionTable.templateId, InspectionTable.templateName, InspectionTable.vesselName, InspectionTable.totalAnswer, InspectionTable.totalQuestion, InspectionTable.lastUpdated, InspectionTable.status, InspectionTable.userId, InspectionTable.conducted FROM InspectionTable WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "InspectionTable.sq:getInspectionById"
  }

  private inner class GetFullInspectionQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("InspectionTable", "TemplateTable", "TemplatePageTable", "TemplatePageSectionTable", "TemplatePageSectionQuestionTable", "AnswerTable", "AnswerSelectionTable", "AnswerFileTable", "AnswerLocationTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("InspectionTable", "TemplateTable", "TemplatePageTable", "TemplatePageSectionTable", "TemplatePageSectionQuestionTable", "AnswerTable", "AnswerSelectionTable", "AnswerFileTable", "AnswerLocationTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(667_847_605, """
    |SELECT
    |    I.id AS inspection_id, I.templateId AS template_id, I.templateName AS template_name, I.vesselName, I.totalAnswer, I.totalQuestion, I.lastUpdated, I.status, I.conducted,
    |    T.id AS t_id, T.name AS t_name, T.version, T.publishedDate, T.numberOfPages, T.numberOfSections, T.numberOfQuestions,
    |    P.id AS page_id, P.title AS page_title, P.orderPosition AS page_pos,
    |    S.id AS section_id, S.title AS section_title, S.orderPosition AS section_pos,
    |    Q.id AS q_id, Q.questionText, Q.guidelines, Q.required, Q.orderPosition AS q_pos, Q.answerType, Q.failedOptionId, Q.neutralOptionId,
    |    A.id AS answer_id, A.notes, A.isRequiredFileOrNotes, A.answerDateIso, A.answerOptionId, A.answerText, A.lastUpdated AS answerLastUpdated, A.findingCategory,
    |    AST.id AS answer_selection_id, AST.answerSelectionId, AST.answerSelectionValue,
    |    AF.id AS answer_file_id, AF.name AS answerFileName, AF.path AS answerFilePath, AF.size AS answerFileSize, AF.type AS answerFileType, AF.uploadStatus AS answerFileStatus,
    |    AL.id AS answer_location_id, AL.name AS answerLocationName, AL.latitude, AL.longitude, AL.street, AL.isoCountryCode, AL.country, AL.postalCode, AL.administrativeArea, AL.subAdministrativeArea, AL.locality, AL.subLocality, AL.thoroughfare, AL.subThoroughfare
    |FROM InspectionTable I
    |LEFT JOIN TemplateTable T ON I.templateId = T.id
    |LEFT JOIN TemplatePageTable P ON T.id = P.templateId
    |LEFT JOIN TemplatePageSectionTable S ON P.id = S.pageId
    |LEFT JOIN TemplatePageSectionQuestionTable Q ON S.id = Q.sectionId
    |LEFT JOIN AnswerTable A ON I.id = A.inspectionId AND Q.id = A.questionId
    |LEFT JOIN AnswerSelectionTable AST ON A.id = AST.answerId
    |LEFT JOIN AnswerFileTable AF ON A.id = AF.answerId
    |LEFT JOIN AnswerLocationTable AL ON A.id = AL.answerId
    |WHERE I.id = ?
    |ORDER BY page_pos, section_pos, q_pos
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "InspectionTable.sq:getFullInspection"
  }

  private inner class GetInspectionsPaginatedQuery<out T : Any>(
    public val userId: String,
    public val limit: Long,
    public val offset: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("InspectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("InspectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_064_595_232, """
    |SELECT InspectionTable.id, InspectionTable.templateId, InspectionTable.templateName, InspectionTable.vesselName, InspectionTable.totalAnswer, InspectionTable.totalQuestion, InspectionTable.lastUpdated, InspectionTable.status, InspectionTable.userId, InspectionTable.conducted FROM InspectionTable
    |WHERE userId = ?
    |ORDER BY conducted DESC
    |LIMIT ? OFFSET ?
    """.trimMargin(), mapper, 3) {
      var parameterIndex = 0
      bindString(parameterIndex++, userId)
      bindLong(parameterIndex++, limit)
      bindLong(parameterIndex++, offset)
    }

    override fun toString(): String = "InspectionTable.sq:getInspectionsPaginated"
  }

  private inner class CountInspectionsQuery<out T : Any>(
    public val userId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("InspectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("InspectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(761_926_676, """SELECT count(*) FROM InspectionTable WHERE userId = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, userId)
    }

    override fun toString(): String = "InspectionTable.sq:countInspections"
  }
}
